<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-container>
        <div class="booking-add">
<!--          <b-card>-->
<!--            <div slot="header">Import from CSV</div>-->
<!--            <b-row>-->
<!--              <b-col>-->
<!--                <b-form-group id="fieldset-laodcsv" label="Import from CSV" label-for="csv_file">-->
<!--                  <b-form-file id="csv_file" name="csv_file" class="form-control"-->
<!--                               @change="importCsv($event)"/>-->
<!--                </b-form-group>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--          </b-card>-->

          <b-card>
            <div slot="header">Agent Details</div>
            <b-row>
              <b-col md="6">
                <b-form-group
                  id="fieldset-agentSelect"
                  label="Select Agent"
                  label-for="agentSelect"
                >
                  <treeselect v-model="form.agent_id" :multiple="false" :options="select2Agents"
                              placeholder="Select Agent"/>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <v-input-travel-agent
                  v-model="form.travel_agent_id"
                  :options="select2TravelAgents"
                  name="travelAgents">
                </v-input-travel-agent>
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            <div slot="header">Booking</div>
            <b-row>
              <b-col md="6">
                <b-form-group label="Booking Date">
                  <flat-pickr
                    v-model="form.booking_date"
                    :config="config"
                    class="form-control"
                    name="date"></flat-pickr>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <v-text-field
                  v-model="form.reference_code"
                  type="text"
                  name="reference_code"
                >
                  <span slot="label">Reference Code</span>
                </v-text-field>
              </b-col>
              <b-col md="3">
                <v-text-field
                  v-model="form.invoice_id"
                  type="text" name="invoice_id"
                  :readonly="true">
                  <span slot="label">Invoice Number</span>
                </v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <v-text-field
                  :required="true"
                  :v="$v.form['trip_description']"
                  @blur="$v.form['trip_description'].$touch()"
                  @focus="$v.form['trip_description'].$reset()"
                  v-model="form.trip_description"
                  type="text"
                  name="trip_description">
                  <span slot="label">Trip Description</span>
                </v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6" lg="3">
                <v-text-field
                  :required="true"
                  :v="$v.form['price']"
                  @blur="$v.form['price'].$touch()"
                  @focus="$v.form['price'].$reset()"
                  inputClasses="text-right"
                  v-model="form.price"
                  type="number"
                  min="0"
                  name="price"
                  prepend="€">
                  <span slot="label">Price</span>
                </v-text-field>
              </b-col>
              <b-col md="6" lg="3">
                <b-form-checkbox
                  id="to_pay"
                  name="to_pay"
                  class="mt-4"
                  v-model="form.to_pay"
                >
                  To Pay?
                </b-form-checkbox>
              </b-col>
              <b-col md="6" lg="3">
                <b-form-group label="Select VAT">
                  <treeselect v-model="form.vat" :multiple="false" :options="select2VAT" placeholder="Select VAT"/>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>

          <b-card v-for="(client, key) in form.clients" :key="'client-'+key">
            <div slot="header">
              <b-row align-v="center">
                <b-col>
                  <b>Client {{key + 1}} - {{client.full_name}}</b>
                </b-col>
                <b-col class="text-right">
                  <b-button @click="deleteClient(key)" variant="outline-secondary" class="m-0">
                    <i class="icon-trash icons"></i>
                  </b-button>
                </b-col>
              </b-row>
            </div>

            <b-row>
              <b-col md="6">
                <v-text-field
                  v-model="client.full_name"
                  type="text"
                  name="full_name"
                >
                  <span slot="label">Full Name</span>
                </v-text-field>
              </b-col>
              <b-col md="3">
                <v-text-field
                  :required="true"
                  v-model="client.persons"
                  type="text"
                  name="persons">
                  <span slot="label">Persons</span>
                </v-text-field>
              </b-col>
              <b-col md="3">
                <v-text-field
                  v-model="client.reference_no"
                  type="text"
                  name="client_reference_no"
                >
                  <span slot="label">Client Reference No</span>
                </v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <v-text-field
                  v-model="client.contact"
                  type="text"
                  name="contact"
                >
                  <span slot="label">Contact</span>
                </v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group label="Pickup Date">
                  <flat-pickr
                    v-model="client.pick_up_date"
                    :config="config"
                    class="form-control"
                    name="date"></flat-pickr>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <v-text-field
                  v-model="client.pick_up_location"
                  :value="client.pick_up_location"
                  type="text"
                  name="pick_up_location">
                  <span slot="label">Pick-Up Location</span>
                </v-text-field>
              </b-col>
              <b-col md="4">
                <v-text-field
                  v-model="client.drop_off_location"
                  :value="client.drop_off_location"
                  type="text"
                  name="drop_off_location">
                  <span slot="label">Drop-Off Location</span>
                </v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <v-input-time :debug='true' v-model="client.ferry" label="Ferry" size="sm"></v-input-time>
              </b-col>
              <b-col md="4">
                <v-text-field
                  v-model="client.flight_no"
                  type="text"
                  name="flight_no"
                >
                  <span slot="label">Flight Number</span>
                </v-text-field>
              </b-col>
              <b-col md="4">
                <b-form-group label="Flight Datetime">
                  <flat-pickr
                    v-model="client.flight_time"
                    :config="config"
                    class="form-control"
                    name="date"></flat-pickr>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group role="group" label="Notes">
                  <b-input-group>
                    <b-form-textarea v-model="client.notes" :rows="3" :max-rows="6">
                    </b-form-textarea>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
          <b-card v-for="(addon, key) in form.addons" :key="'addon-'+key">
            <div slot="header">
              <b-row align-v="center">
                <b-col>
                  <b>Addon {{key+1}} - {{addon.item}}</b>
                </b-col>
                <b-col class="text-right">
                  <b-button @click="deleteAddon(key)" variant="outline-secondary" class="m-0">
                    <i class="icon-trash icons"></i>
                  </b-button>
                </b-col>
              </b-row>
            </div>

            <b-row>
              <b-col md="6">
                <v-text-field
                  v-model="addon.item"
                  type="text"
                  name="addon-item"
                >
                  <span slot="label">Item</span>
                </v-text-field>
              </b-col>
              <b-col md="3">
                <v-text-field
                  inputClasses="text-right"
                  v-model="addon.price"
                  type="number"
                  min="0"
                  name="price"
                  prepend="€">
                  <span slot="label">Price</span>
                </v-text-field>
              </b-col>
              <b-col md="3">
                <b-form-group label="Select VAT">
                  <treeselect v-model="addon.vat" :multiple="false" :options="select2VAT" placeholder="Select VAT"/>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
          <b-row class="my-4">
            <b-col>
              <b-button @click="addClient" variant="primary" class="mr-auto">Add Client</b-button>
              <b-button @click="addAddon" variant="primary" class="mr-auto">Add Addon</b-button>
            </b-col>
            <b-col class="text-right">
              <b-button type="submit" variant="success" @click="submit">
                <i class="fa fa-dot-circle-o"></i> Save
              </b-button>
              <b-button type="reset" variant="danger" to="/bookings">
                <i class="fa fa-ban"></i> Cancel
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import { common, validations } from './mixins'
import 'es6-promise/auto'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import moment from 'moment'

export default {
  name: 'BookingEdit',
  props: ['id'],
  components: {
    flatPickr,
    Treeselect
  },
  data () {
    return {
      templates: {
        client: {
          id: null,
          reference_no: null,
          full_name: null,
          contact: null,
          persons: null,
          pick_up_date: null,
          pick_up_location: null,
          drop_off_location: null,
          ferry: null,
          flight_no: null,
          flight_time: null,
          notes: null
        },
        addon: {
          id: null,
          item: null,
          price: null,
          vat: 18
        }
      },
      form: {
        id: null,
        invoice_id: null,
        agent_id: null,
        travel_agent_id: null,
        booking_date: null,
        reference_code: null,
        trip_description: '',
        price: '',
        to_pay: false,
        vat: 18,
        clients: [
          {
            id: null,
            full_name: null,
            persons: null,
            reference_no: null,
            contact: null,
            pick_up_date: null,
            pick_up_location: null,
            drop_off_location: null,
            ferry: null,
            flight_no: null,
            flight_time: null,
            notes: null
          }
        ],
        addons: []
      },
      select2Agent: null,
      select2VAT: [
        { label: '18%', id: 18 },
        { label: '0%', id: 0 }
      ],
      config: {
        enableTime: true,
        altInput: true,
        altFormat: 'd/m/Y H:i',
        dateFormat: 'Z'
      }
    }
  },
  validations: {
    ...validations
  },
  methods: {
    submit () {
      let payload = { ...this.form }
      let xhr = this.$store.dispatch('bookings/store', payload)

      xhr.then(
        (res) => {
          this.$router.push({ path: '/bookings/' + res.data.data.id + '/edit' })
        }
      )
    },
    addClient () {
      this.form.clients.push(Object.assign({}, this.templates.client))
    },
    deleteClient (key) {
      this.form.clients.splice(key, 1)
    },
    addAddon () {
      this.form.addons.push(Object.assign({}, this.templates.addon))
    },
    deleteAddon (key) {
      this.form.addons.splice(key, 1)
    },
    chunkArray (myArray, chunk_size) {
      let results = []

      while (myArray.length) {
        results.push(myArray.splice(0, chunk_size))
      }

      return results
    },
    mapCSV (csv) {
      let lines = csv.split('\n')
      let result = []
      let bookings = []

      lines = lines.map(function (line, indexLine) {
        return line.split(',')
      })

      let bookingLines = lines.splice(0, 13)
      lines.splice(lines.length - 3, 3)

      let currentStart = 0
      lines.forEach(function (line, index) {
        if (line[0] === 'Total Pickup') {
          let booking = []
          for (let i = currentStart; i <= index; i++) {
            booking.push(lines[i])
          }
          bookings.push(booking)
          currentStart = index + 1
        }
      })

      this.form.reference_code = bookingLines[4][1]
      this.form.trip_description = bookingLines[5][10]
      this.form.clients = []

      let isArrival = this.form.trip_description === '(Arrival Transfer)'
      let isDeparture = this.form.trip_description === '(Departure Transfer)'

      let transferDate = bookingLines[5][0].replace('Transfer Date: ', '').split('/')

      bookings.forEach(function (booking, index) {
        let pickUpDetails = booking.shift()
        let totalPickup = booking.pop()
        let clients = this.chunkArray(booking, 3)

        let time = pickUpDetails[0].split(':')

        clients.forEach(function (client, ci) {
          let _client = {
            id: null,
            full_name: client[0][8],
            persons: client[0][22] + '+' + client[0][23] + '+' + client[0][25],
            reference_no: client[0][16],
            contact: '-',
            pick_up_date: new Date(transferDate[2], transferDate[1] - 1, transferDate[0], time[0], time[1]).toISOString(),
            pick_up_location: null,
            drop_off_location: null,
            ferry: null,
            flight_no: client[0][27],
            flight_time: null,
            notes: client[1][8]
          }

          if (isArrival) {
            _client.drop_off_location = pickUpDetails[3]
            _client.pick_up_location = 'Gozo Ferry'
          } else if (isDeparture) {
            _client.drop_off_location = 'Gozo Ferry'
            _client.pick_up_location = pickUpDetails[3]
          }

          this.form.clients.push(_client)
        }.bind(this))
      }.bind(this))
    },
    importCsv (e) {
      if (window.FileReader) {
        var reader = new FileReader()
        reader.readAsText(e.target.files[0])
        // Handle errors load
        reader.onload = function (event) {
          var csv = event.target.result
          this.mapCSV(csv)
        }.bind(this)
        reader.onerror = function (evt) {
          if (evt.target.error.name === 'NotReadableError') {
            alert('Can\'t read file !')
          }
        }
      } else {
        alert('FileReader are not supported in this browser.')
      }
    }
  },
  mixins: [common],
  created () {
    this.$store.dispatch('agents/index')
    this.$store.dispatch('travelAgents/index')
    this.$store.dispatch('locations/index')
  }
}
</script>



// WEBPACK FOOTER //
// src/views/bookings/Add.vue